import { format, parseISO, differenceInYears } from "date-fns";
import { it } from "date-fns/locale";

export const DOMAINS = [
  { key: "performance_visiva", label: "Performance Visiva", short: "Perf. Visiva" },
  { key: "recettivo", label: "Recettivo", short: "Recettivo" },
  { key: "mand", label: "Mand", short: "Mand" },
  { key: "tact", label: "Tact", short: "Tact" },
  { key: "ecoico", label: "Ecoico", short: "Ecoico" },
  { key: "intraverbale", label: "Intraverbale", short: "Intraverbale" },
  { key: "imitazione", label: "Imitazione", short: "Imitazione" },
];

export const DOMAIN_DESCRIPTIONS = {
  performance_visiva: "Abilità visuo-percettive: matching, puzzle, sequenze, discriminazione visiva.",
  recettivo: "Comprensione del linguaggio: il bambino risponde a istruzioni verbali con un'azione.",
  mand: "Richieste: il bambino chiede ciò che desidera, controllato dalla motivazione.",
  tact: "Denominazione: il bambino nomina oggetti, azioni e proprietà presenti nell'ambiente.",
  ecoico: "Ripetizione vocale: il bambino ripete suoni o parole su modello verbale.",
  intraverbale: "Risposte verbali a stimoli verbali (domande, conversazione, completamenti).",
  imitazione: "Imitazione motoria: il bambino riproduce un'azione su modello.",
};

export const domainLabel = (key) => DOMAINS.find((d) => d.key === key)?.label || key;

// Prompt hierarchy: I (independent) -> V -> G -> M -> F (most intrusive)
export const PROMPT_LEVELS = [
  { key: "indipendente", label: "Indipendente", short: "Indip.", code: "I", color: "#0F766E" },
  { key: "verbale", label: "Aiuto verbale", short: "Verbale", code: "V", color: "#2563EB" },
  { key: "gestuale", label: "Aiuto gestuale", short: "Gestuale", code: "G", color: "#7C3AED" },
  { key: "modello", label: "Modello", short: "Modello", code: "M", color: "#DB2777" },
  { key: "fisico", label: "Aiuto fisico", short: "Fisico", code: "F", color: "#DC2626" },
];
export const promptInfo = (key) => PROMPT_LEVELS.find((p) => p.key === key) || PROMPT_LEVELS[0];

export const STALE_DAYS = 7;

export const CHART_COLORS = {
  data: "#0F766E",
  dataAcquired: "#15803D",
  criterion: "#F59E0B",
  trend: "#64748B",
  phase: "#2563EB",
  grid: "#E2E8F0",
  total: "#94A3B8",
};

export const todayISO = () => format(new Date(), "yyyy-MM-dd");

export const fmtDate = (iso, pattern = "d MMM yyyy") => {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), pattern, { locale: it });
  } catch {
    return iso;
  }
};

export const ageFromBirth = (iso) => {
  if (!iso) return null;
  try {
    return differenceInYears(new Date(), parseISO(iso));
  } catch {
    return null;
  }
};

export const pct = (v) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(Number.isInteger(v) ? 0 : 1)}%`);

export const slugify = (s) =>
  (s || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const trendLabel = (dir) =>
  ({ crescente: "In crescita", decrescente: "In calo", stabile: "Stabile", insufficiente: "Dati insufficienti" }[dir] || "—");

export const deadlineLabel = (a) => {
  if (!a?.data_obiettivo) return null;
  const g = a.giorni_all_obiettivo;
  switch (a.esito_obiettivo) {
    case "in_ritardo": return { tone: "late", text: `In ritardo di ${Math.abs(g)} ${Math.abs(g) === 1 ? "giorno" : "giorni"}` };
    case "in_scadenza": return { tone: "soon", text: g === 0 ? "Scade oggi" : `Scade tra ${g} ${g === 1 ? "giorno" : "giorni"}` };
    case "raggiunto_in_tempo": return { tone: "ok", text: "Obiettivo raggiunto nei tempi" };
    case "raggiunto_in_ritardo": return { tone: "okLate", text: `Raggiunto con ${Math.abs(g)} giorni di ritardo` };
    default: return { tone: "plan", text: `Obiettivo tra ${g} giorni` };
  }
};

export const deadlineClass = (tone) =>
  ({
    late: "text-rose-800 bg-rose-50 border-rose-200",
    soon: "text-amber-800 bg-amber-50 border-amber-200",
    ok: "text-emerald-800 bg-emerald-50 border-emerald-200",
    okLate: "text-emerald-800 bg-emerald-50 border-emerald-200",
    plan: "text-slate-700 bg-slate-50 border-slate-200",
  }[tone] || "text-slate-700 bg-slate-50 border-slate-200");

export const fmtDelta = (v, suffix = "") => {
  if (v === null || v === undefined) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${Number.isInteger(v) ? v : v.toFixed(1)}${suffix}`;
};
